import siteConfig from '../../../siteConfig';
import { API_DOMAIN } from '../../../components/constants';
export const clientBuild = `${siteConfig.version} (${siteConfig.build_no})`;
export function ownApiUrl(value) {
 if (!value) return false;
 try { const url=new URL(String(value || ''),API_DOMAIN); return [API_DOMAIN].some(base => base && new URL(base).origin===url.origin); } catch { return false; }
}
export const clientHeaders = () => ({ 'X-SRM-Client':'new_web','X-SRM-Build-Version':clientBuild });
export function reportingUrl(value) { try { return new URL(String(value || ''),API_DOMAIN).pathname.replace(/\/+$/,'')==='/system-v1/client-errors'; } catch { return false; } }
